module.exports = __webpack_public_path__ + "img/btn_mock1_demo.89ff708f.png";